import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Container, Form, Button, Card, Spinner, Row, Col } from "react-bootstrap";
import axios from "axios";
import logo from "../../logo.png";
import "../login.css";

const Traceability = () => {
  const [searchId, setSearchId] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSearch = async (e) => {
    e.preventDefault();
    setError(null);

    const token = localStorage.getItem("token");
    console.log("Mencari dengan ID:", searchId);
    console.log(
      "Endpoint yang dipanggil:",
      `https://c-greenproject.org:8000/search/${searchId}`
    );

    try {
      const response = await axios.get(
        `https://c-greenproject.org:8000/search/${searchId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Response:", response.data);
      navigate(`/traceability/${searchId}`, {
        state: { result: response.data },
      });
    } catch (err) {
      console.error("Error fetching data:", err);
      setError(err.response?.data?.msg || "Error saat mencari data");
    }
  };

  return (
    <div className="content">
      <header className="bg-light py-3 shadow-sm header-well">
        <Container>
          <Row className="align-items-center">
            <Col xs={12} md={6} className="d-flex align-items-center">
              <img src={logo} alt="Logo" width={40} height={45} className="me-2" />
              <strong className="fs-2">Cassava Super</strong>
            </Col>
          </Row>
        </Container>
      </header>

      <Container className="mt-4">
        <Card className="p-4 mb-3 shadow">
          <h2 className="mb-3 text-center">
            <strong>Traceability</strong>
          </h2>

          <Form onSubmit={handleSearch} className="box">
            <Form.Group className="mb-3">
              <Form.Label className="align-item-center">
                Input Order ID
              </Form.Label>
              <Form.Control
                type="text"
                value={searchId}
                onChange={(e) => setSearchId(e.target.value)}
                placeholder="Masukkan UUID produk"
              />
            </Form.Group>

            <div className="text-center">
              <Button type="submit" className="btn btn-submit">
                Search
              </Button>
            </div>

            {error && <p className="text-danger mt-3">Error: {error}</p>}
          </Form>
        </Card>
      </Container>

      <div className="text-center mt-4">
        <Link to="/" className="back">
          Back To Home
        </Link>
      </div>
    </div>
  );
};

export default Traceability;
